import * as React from 'react'

import { BoxProps, DOMRef, ScopedCSSRules } from '@dna/react-types'
import { css, cx } from '@dna/core'
import { filterDOMProps, useStyleProps, viewStyleProps } from '../utils'

function Box(props: BoxProps, ref: DOMRef<HTMLElement>) {
  let {
    UNSAFE_className,
    UNSAFE_style,
    as: ElementType = 'div',
    children,
    css: styleProps = {},
    ...otherProps
  } = props

  let {
    styleProps: { className, style },
  } = useStyleProps(
    { ...styleProps, UNSAFE_className, UNSAFE_style },
    viewStyleProps
  )

  return (
    <ElementType
      {...filterDOMProps(otherProps)}
      ref={ref}
      className={cx(css(style as ScopedCSSRules), className)}
    >
      {children}
    </ElementType>
  )
}

/**
 * Box is the most low-level layout component provided by DNA. Its job is to render an individual element on the screen.
 *
 * @name
 * Box
 *
 * @see
 * https://dna.telstrahealth.com/components/box
 *
 * @example
 * <Box as="span">Hello</Box>
 **/
let _Box = React.forwardRef(Box)
export { _Box as Box }
